import { useEffect } from "react";
import { useLocation, matchRoutes } from "src/router";
import { getCurrentScope } from "src/lib/monitoring";

import { jsonSlugRoutes } from "./json-slug-routes";
import { SlugRoutes } from "./slug-routes";

// Hook to set transaction name in sentry
export function useUpdateSentryTransactionNamesForWorkspaceRoutes() {
  const location = useLocation();

  useEffect(() => {
    // First entry is the * match for :root_workspace_slug
    // If there's a second entry, it's a more specific match
    const pathMatch = routePatternFromJsonRoutes(location.pathname);

    if (pathMatch) {
      const sentrySpan = getCurrentScope().getScopeData().span;

      sentrySpan?.updateName(pathMatch);
    }
  }, [location]);
}

export function routePatternFromJsonRoutes(pathname: string): string | null {
  const matches = matchRoutes(
    [
      {
        path: "/:root_workspace_slug/*",
        children: jsonSlugRoutes.concat({
          path: "*",
          element: SlugRoutes(),
        }),
      },
    ],
    pathname,
  );

  // First entry is the workspace wildcard; the page route is the next one with a path, past any pathless layout routes.
  let pattern =
    matches?.slice(1).find((match) => match.route.path)?.route.path ?? null;

  if (pattern && !pattern.startsWith("/")) {
    pattern = `/${pattern}`;
  }

  return pattern;
}
